// src/features/company/api.ts
import api from 'src/shared/api/axios';
import type { CompanyType } from './types';

export type CompanyUser = {
    id: string; // CompanyMember id
    companyId: string;
    joinedAt: string;
    role: {
        id: string;
        name: string; // COMPANY_ADMIN / COMPANY_USER ...
        scope: string; // "COMPANY"
    };
    user: {
        id: string;
        email: string;
        name: string;
        status: string; // "ACTIVE" | "INACTIVE" | ...
        createdAt: string;
        updatedAt: string;
    };
};

export type InviteCompanyUserParams = {
    email: string;
    name?: string;
    companyRoleName?: string; // 기본 COMPANY_USER
};

export type InviteCompanyUserResult = {
    user: {
        id: string;
        email: string;
        name: string;
    };
    membership: {
        id: string;
        companyId: string;
        userId: string;
        role: string;
    };
    plainPassword?: string | null;
};

export type CompanyPartner = {
    id: string;
    name: string;
    type: CompanyType | null;
    ownerCompanyId: string | null;
    createdAt: string;
    updatedAt: string;
    status: string;
};

/**
 * 유저 관련
 */
// 회사 유저 목록
export async function listCompanyUsers(): Promise<CompanyUser[]> {
    const { data } = await api.get('/company/users');
    return data.data;
}

// 회사 유저 초대 (이메일 기반)
export async function inviteCompanyUser(params: InviteCompanyUserParams): Promise<InviteCompanyUserResult> {
    const { data } = await api.post('/company/users/invite', params);
    return data.data;
}

// 회사 유저 역할 변경 (COMPANY_ADMIN / COMPANY_USER 등)
export async function updateCompanyMemberRole(companyMemberId: string, roleName: string): Promise<void> {
    await api.patch(`/company/users/${companyMemberId}/role`, { roleName });
}

// 회사 유저 제외 (CompanyMember 삭제)
export async function deleteCompanyMember(companyMemberId: string): Promise<void> {
    await api.delete(`/company/users/${companyMemberId}`);
}

/**
 * 파트너 관련
 */
// 파트너 회사 목록
export async function listCompanyPartners(): Promise<CompanyPartner[]> {
    const { data } = await api.get('/company/partners');
    console.log('company partners: ', data.data);
    return data.data;
}

export async function createCompanyPartner(payload: { name: string; type?: CompanyType }): Promise<CompanyPartner> {
    const { data } = await api.post('/company/partners', payload);
    return data.data;
}

export async function updateCompanyPartner(
    id: string,
    payload: { name?: string; type?: CompanyType | '' },
): Promise<CompanyPartner> {
    const { data } = await api.patch(`/company/partners/${id}`, payload);
    return data.data;
}

export async function deleteCompanyPartner(id: string): Promise<void> {
    await api.delete(`/company/partners/${id}`);
}
